import { RequestToApproveResponseSuccess } from 'api';

export default function sortByDatesInDESCOrder(
  a: RequestToApproveResponseSuccess,
  b: RequestToApproveResponseSuccess,
) {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
